import React from "react";
import { useStore as useAuthStore } from "auth/store";
import { TaskList } from "tasks/components/TaskList/TaskList";
import { shouldShowTasks } from "tasks/components/TaskList/TaskLists";

export const AssignedTasks = () => {
  const {
    state: { user },
  } = useAuthStore();

  if (!user || shouldShowTasks(user)) return null;

  return (
    <TaskList
      showEmpty
      filters={{
        assignee: [user.id],
        city: null,
        triaged: null,
      }}
      id="assigned"
      limit={50}
      title="Assigned tasks"
    />
  );
};
